import { toast } from 'react-toastify';

const originalSuccess = toast.success;
const originalError = toast.error;

toast.success = (message, options = {}) =>
    originalSuccess(message, { autoClose: 5000, ...options });

toast.error = (message, options = {}) =>
    originalError(message, { autoClose: 8000, ...options });

export default toast;
